window.addEventListener('DOMContentLoaded', () => {
  const sectionContainer = document.querySelector('.reviews-section');

  if (!sectionContainer) {
    return;
  }

  let reviewsFlickity;

  const sectionId = sectionContainer.getAttribute('data-section-id');
  const slideshow = sectionContainer.querySelector('#Reviews-' + sectionId);

  const reviewsSliderOptions = {
    adaptiveHeight: true,
    avoidReflow: true,
    pageDots: false,
    prevNextButtons: false,
    autoPlay: false,
    groupCells: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          prevNextButtons: true,
        },
      },
    ],
  };

  function initFlickity() {
    if (!window.matchMedia('(min-width: 1440px)').matches) {
      reviewsFlickity = new FlickityResponsive(slideshow, {
        ...reviewsSliderOptions,
      });
    }
  }

  function handleResize() {
    if (window.matchMedia('(min-width: 1440px)').matches) {
      reviewsFlickity?.destroy();
      return;
    }

    initFlickity();
  }

  window.addEventListener(
    'resize',
    theme.utils.debounce(300, function () {
      handleResize();
    })
  );

  initFlickity();
});
